import type { IPagination } from "../../../../types/models/pagination.models.types";
import type { IUser } from "../../../../types/models/user.models.types";
import { useGetHttp } from "../../http.hook";

export interface IFavoriteSocialCsv {
  id: string;
  handle: string;
  status: {
    status: string;
    timestamp: Date;
    user: IUser;
  };
  createdAt: Date;
}

interface IResponse {
  csvLogs: Array<IFavoriteSocialCsv>;
  pagination: IPagination;
}

export function useGetAllUploadLogsAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/favourite-socials/csv/:csvId/items",
  });
}
